export default [
  'USA',
  'ITALY',
  'THAILAND',
  'GREECE',
  'FRANCE',
  'GEORGIA',
  'HUNGARY',
  'UNITED ARAB EMIR',
  'UNITED KINGDOM',
  'GERMANY',
  'AUSTRIA',
  'CYPRUS',
  'SPAIN',
];
